
define('text!modules/creatives/concept/templates/assignModalHold.html',[],function () { return '<div class="unload-alert">\n    <div class="w-body">\n        <div class="message">\n            <div class="body-content move-top"><div class="view-loader"></div></div>\n        </div>\n    </div>\n</div>';});

